<template>
  <button
    class="h-[50px] w-full min-w-min max-w-[257px] rounded-full border-2 border-[#16114F] !bg-[#5090f3] font-Aeonik font-bold uppercase text-white shadow-[0px_2px_0px_0px_#16114F] hover:!bg-yellow hover:!text-[#16114F] active:!bg-white md:max-w-[334px] md:normal-case"
  >
    <slot />
  </button>
</template>
